import React from 'react';
import { clsx } from 'clsx';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className,
  variant = 'rect',
}) => {
  const baseStyles = "shimmer-bg animate-pulse-gentle";
  
  const variants = {
    text: "h-3 w-full rounded",
    rect: "h-24 w-full rounded-xl",
    circle: "h-12 w-12 rounded-full"
  };

  return (
    <div
      className={clsx(baseStyles, variants[variant], className)}
      aria-hidden="true"
    />
  );
};
